package gr.tech.pdfgenerator.styles

import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.style.CssStyle
import gr.tech.pdfgenerator.util.CONSTANTS.FONT_FAMILY2
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.css.px

val HomePageStyle = CssStyle {
    base {
        Modifier
            .fillMaxSize()
            .padding(12.px)
    }
}

val HomeHeaderStyle = CssStyle {
    base {
        Modifier
            .fontFamily(FONT_FAMILY2)
            .fontSize(1.75.cssRem)
    }
}